module.exports = __webpack_public_path__ + "img/photo_2023-11-22 14.30.25.4fe687c0.jpg";